import gql from 'graphql-tag';

export const batchMutations = (mutationName, mutations) => {
  const joinedMutations = `mutation {${mutations.map(
    (mutation, i) => `${mutationName}${i}: ${mutation}\n`
  )}}`;
  return gql(joinedMutations);
};
